import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit'
import { ETimelinePostStatus, ShareTimelineItem, SharingTimelineRequest } from 'types'
import { getSharedTimeline } from '../../api/teams'
import { RootState } from '../store'

const getTimelinePayloadCreator = async (request: SharingTimelineRequest) => {
  const response = await getSharedTimeline(request)
  return response.data
}

export const getSharedTimelineById = createAsyncThunk(
  'shared-timeline/by-user-id',
  getTimelinePayloadCreator,
)

export const getSharedTimelineSilent = createAsyncThunk(
  'shared-timeline/silent',
  getTimelinePayloadCreator,
)

export const sharedTimelineSlice = createSlice({
  name: 'sharedTimeline',
  initialState: {
    timeline: null as ShareTimelineItem[] | null,
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSharedTimelineById.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getSharedTimelineById.fulfilled, (state, action) => {
        state.timeline = action.payload
        state.isLoading = false
      })
      .addCase(getSharedTimelineById.rejected, (state) => {
        state.isLoading = false
        state.timeline = null
      })
      .addCase(getSharedTimelineSilent.fulfilled, (state, action) => {
        state.timeline = action.payload
        state.isLoading = false
      })
      .addCase(getSharedTimelineSilent.rejected, (state) => {
        state.isLoading = false
        state.timeline = null
      })
      .addCase('currentUser/logout', (state) => {
        state.timeline = []
      })
  },
})

export const selectSharedTimelineSlice = (state: RootState) => state.sharedTimeline

export const selectNewTimelineItemsCount = createSelector(
  [selectSharedTimelineSlice],
  (sharedTimeline): number | undefined => {
    const { timeline } = sharedTimeline
    if (!timeline) return undefined

    return timeline.filter((item) => item.status === ETimelinePostStatus.new).length
  },
)
